import React, { Children } from 'react';
// ---------------------------------------------------------------------------
// Legacy SEO Crawl Links
// ---------------------------------------------------------------------------
// This nav exists ONLY to preserve crawlability of existing Storm Taekwondo
// pages. The links MUST be real <a href> anchors in the raw HTML source.
// Do not wrap them in <Link> from react-router-dom — full-page navigation
// is intentional so external/legacy WebsiteForge URLs work correctly.
// Do not add rel="nofollow". Do not hide via display:none / opacity:0 / etc.
// ---------------------------------------------------------------------------
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
const MENU_ITEMS: MenuItem[] = [{
  title: 'Service Areas',
  url: '',
  children: [{
    title: 'Farmington Hills Martial Arts Program | Storm Taekwondo',
    url: '/farmington-hills-martial-arts-program-storm-taekwondo'
  }, {
    title: 'Novi Martial Arts Program | Storm Taekwondo',
    url: '/novi-martial-arts-program-storm-taekwondo'
  }, {
    title: 'Commerce Martial Arts Program | Storm Taekwondo',
    url: '/commerce-martial-arts-program-storm-taekwondo'
  }, {
    title: 'Livonia Martial Arts Program | Storm Taekwondo',
    url: '/livonia-martial-arts-program-storm-taekwondo'
  }, {
    title: 'Farmington Martial Arts Program | Storm Taekwondo',
    url: '/farmington-martial-arts-program-storm-taekwondo'
  }, {
    title: 'Waterford Martial Arts Program | Storm Taekwondo',
    url: '/waterford-martial-arts-program-storm-taekwondo'
  }, {
    title: 'Northville Martial Arts Program | Storm Taekwondo',
    url: '/northville-martial-arts-program-storm-taekwondo'
  }]
}, {
  title: 'Site Links',
  url: '',
  children: [{
    title: 'Home',
    url: '/'
  }, {
    title: 'About Us',
    url: '/about-storm-taekwondo.html'
  }, {
    title: 'Storm Swag',
    url: '/swag'
  }, {
    title: 'Summer Camp',
    url: '/summer-camp'
  }, {
    title: 'Programs',
    url: '/Programs.html'
  }, {
    title: 'Adults',
    url: '/karate-adult-classes.html'
  }, {
    title: 'Children',
    url: '/karate-kids-classes.html'
  }, {
    title: 'Family',
    url: '/FamilyKarateClasses.html'
  }, {
    title: 'Fitness',
    url: '/are-martial-arts-for-fitness'
  }, {
    title: 'FREE WEEK / Sign Up',
    url: '/SignMeUp'
  }, {
    title: 'Contact Us',
    url: '/ContactUs.html'
  }, {
    title: 'Testimonials',
    url: '/Testimonials.html'
  }, {
    title: 'Do Some Martial Arts',
    url: '/do-some-martial-arts'
  }, {
    title: 'Adult Classes',
    url: '/karate-adult-classes'
  }, {
    title: 'Storm Overview',
    url: '/31.html'
  }]
}, {
  title: 'SEO Sitemap',
  url: '',
  children: [{
    title: 'Storm Taekwondo Full Sitemap & SEO Index',
    url: '/17482.html'
  }, {
    title: '2 – J',
    url: '/17482.html'
  }, {
    title: 'J – K',
    url: '/17482.html'
  }, {
    title: 'KARATE C – KARATE F',
    url: '/17482.html'
  }, {
    title: 'KARATE F – KARATE N',
    url: '/17482.html'
  }, {
    title: 'KARATE N – KARATE P',
    url: '/17482.html'
  }, {
    title: 'K – M',
    url: '/17482.html'
  }, {
    title: 'MARTIAL ARTS C – MARTIAL ARTS N',
    url: '/17482.html'
  }, {
    title: 'M – U',
    url: '/17482.html'
  }, {
    title: 'U – Z',
    url: '/17482.html'
  }]
}, {
  title: 'Service Area SEO Index',
  url: '',
  children: [{
    title: 'Storm Taekwondo Service Area Index',
    url: '/farmington-hills-martial-arts-program-storm-taekwondo'
  }]
}];
function CrawlList({
  links
}: {
  links: {
    title: string;
    url: string;
  }[];
}) {
  return <ul className="flex flex-wrap gap-x-4 gap-y-1.5 list-none p-0 m-0" data-id="element-1835">
      {links.map(l => <li key={l.url + l.title} className="m-0" data-id="element-1836">
          <a href={l.url} className="text-gray-warm hover:text-storm-red transition-colors underline-offset-2 hover:underline" data-id="element-1837">
            {l.title}
          </a>
        </li>)}
    </ul>;
}
export function LegacySeoCrawlLinks() {
  return <nav aria-label="Legacy SEO crawl links" className="legacy-seo-crawl-links bg-paper border-t border-subtle-gray text-xs text-gray-warm" data-id="element-1838">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col gap-2" data-id="element-1839">
        {MENU_ITEMS.map(item => <details key={item.title} className="group" data-id="element-1840">
            <summary className="cursor-pointer select-none font-bold uppercase tracking-wide text-ink/70 hover:text-storm-red py-1.5" data-id="element-1841">
              {item.url ? <a href={item.url} className="text-inherit hover:text-storm-red transition-colors" data-id="element-1842">
                  {item.title}
                </a> : item.title}
            </summary>
            {item.children && item.children.length > 0 && <div className="mt-2 pl-1 pb-2" data-id="element-1843">
                <CrawlList links={item.children} data-id="element-1844" />
              </div>}
          </details>)}
      </div>
    </nav>;
}